import React, { useState, useEffect } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom"; // Import Outlet dan useLocation
import Sidebar from "../components/sidebar"; // Pastikan path ini benar
import Notification from "../components/Notification"; // Pastikan path ini benar
import ProfileDropdown from "../components/ProfileDropdown"; // Pastikan path ini benar

// Impor komponen laporan jika Anda ingin Dashboard.jsx menangani penampilannya
import DailyReport from "../components/DailyReport"; // Contoh
import WeeklyReport from "../components/WeeklyReport"; // Contoh
import MonthlyReport from "../components/MonthlyReport"; // Contoh

import "../styles/Dashboard.css"; // Pastikan CSS ini diimport

const Dashboard = () => {
    const navigate = useNavigate();
    const location = useLocation(); // Digunakan untuk mengetahui path saat ini
    
    // State untuk data dashboard utama (jika ada)
    const [reportType, setReportType] = useState("daily");
    const [fade, setFade] = useState(false);
    const [username, setUsername] = useState(null);

    useEffect(() => {
        const storedUsername = localStorage.getItem("username");
        if (!storedUsername) {
            navigate("/login", { replace: true });
        } else {
            setUsername(storedUsername);
        }
    }, [navigate]);

    if (!username) return null; // Jangan render jika username belum di-load

    const handleReportChange = (type) => {
        setFade(false);
        setTimeout(() => {
            setReportType(type);
            setFade(true);
        }, 200);
    };

    // Tentukan apakah kita berada di path dashboard utama atau di nested route
    // Jika path adalah '/dashboard' atau '/dashboard/', maka ini adalah dashboard utama
    const isDashboardMainPath = location.pathname === '/dashboard' || location.pathname === '/dashboard/';


    return (
        <div className="dashboard-container">
            {/* Bagian Header Dashboard */}
            <div className="dashboard-header">
                <div className="header-title">
                    <h2>Dashboard - {username}</h2>
                </div>
                <div className="header-right">
                    <Notification username={username} />
                    <ProfileDropdown username={username} />
                </div>
            </div>

            {/* Sidebar akan selalu dirender oleh komponen Dashboard */}
            <Sidebar />

            {/* Konten Utama Dashboard */}
            <div className="dashboard-content">
                {isDashboardMainPath ? (
                    // Jika ini adalah path dashboard utama (/dashboard atau /dashboard/)
                    // maka render konten laporan default (Harian, Mingguan, Bulanan)
                    <>
                        <div className="report-switcher">
                            <button
                                onClick={() => handleReportChange("daily")}
                                className={reportType === "daily" ? "active" : ""}
                            >
                                Harian
                            </button>
                            <button
                                onClick={() => handleReportChange("weekly")}
                                className={reportType === "weekly" ? "active" : ""}
                                >
                                Mingguan
                            </button>
                            <button
                                onClick={() => handleReportChange("monthly")}
                                className={reportType === "monthly" ? "active" : ""}
                            >
                                Bulanan
                            </button>
                        </div>

                        <div className={`report-container ${fade ? "fade-in" : "fade-out"}`}>
                            {reportType === "daily" && <DailyReport username={username} />}
                            {reportType === "weekly" && <WeeklyReport username={username} />}
                            {reportType === "monthly" && <MonthlyReport username={username} />}
                        </div>
                    </>
                ) : (
                    // Jika bukan path dashboard utama, berarti ini adalah nested route
                    // Render komponen yang cocok dengan nested route di sini
                    <Outlet />
                )}
            </div>
        </div>
    );
};

export default Dashboard;